























import Vue from 'vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import { getInstance } from '../plugins/authWrapper';

export default Vue.extend({
  name: 'SessionManagementNotification',

  data() {
    return {
      countDown: undefined,
      intervalId: undefined
    };
  },

  computed: {
    ...mapState('components/session-management', {
      showSessionManagementDialog: 'showDialog'
    }),
    ...mapState('user', ['firstName'])
  },

  watch: {
    countDown(value) {
      if (this.showSessionManagementDialog && value < 1) {
        this.$auth.logout({
          returnTo: window.location.origin
        });
      }
    },

    showSessionManagementDialog(sessionActive) {
      if (sessionActive) {
        this.watchForStorageChange();
        this.countDown = 60;
        this.intervalId = setInterval(() => {
          this.countDown--;
        }, 1000);
      } else {
        window.removeEventListener('storage', this.onStorageChange);
        clearInterval(this.intervalId);
        this.countDown = undefined;
      }
    }
  },

  methods: {
    ...mapMutations('components/session-management', {
      setSessionManagementDialog: 'setDialog'
    }),
    ...mapMutations('user', { setUserAccessToken: 'setAccessToken' }),
    ...mapActions('user', ['loadUserAccountDetails']),

    watchForStorageChange() {
      window.addEventListener('storage', this.onStorageChange);
    },

    onStorageChange(e) {
      const auth0Renewed = /^@@auth0spajs@@/.test(e.key) && e.newValue != null; // If the storage value changes but isn't null it means the session was refreshed so the dialog is closed.
      if (auth0Renewed) {
        this.closeDialogAndContinueSession();
      }
    },

    closeDialogAndContinueSession() {
      this.$sessionManager.startSessionManagement();
      clearInterval(this.intervalId);
      this.countDown = undefined;
      this.setSessionManagementDialog(false);
    },

    async confirmSessionContinuation(continueSession) {
      if (continueSession) {
        try {
          await getInstance().getTokenSilently({
            ignoreCache: true
          });
          this.closeDialogAndContinueSession();
          await this.loadUserAccountDetails({
            id: this.$auth.user.sub
          });
        } catch (e) {
          await getInstance().logout({
            returnTo: window.location.origin
          });
        }
      } else {
        await getInstance().logout({
          returnTo: window.location.origin
        });
      }
    }
  }
});
